module.exports = "<!--page-wrapper Start-->\r\n<div class=\"page-wrapper\">\r\n    <router-outlet></router-outlet>\r\n</div>\r\n<!--page-wrapper Ends-->"